import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reviewDetailView" }

import { onMounted, ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import {
  AuditControllerService,
  AuditRequest,
  PostCommentControllerService,
  PostCommentVO,
  PostControllerService,
  PostVO,
  WriteUpControllerService,
  WriteUpVO,
} from "../../generated";
import { useRoute } from "vue-router";
import MdViewer from "@/components/MdViewer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewDetailView',
  setup(__props) {

const data = ref<PostVO | PostCommentVO | WriteUpVO>();
const route = useRoute();
// 获取router的参数
const id = route.params.id as string;
let type = "";
let typeNum = 0;
if (route.path.startsWith("/review/")) type = route.path.slice(8, -1);
if (type.startsWith("postComment")) {
  typeNum = 1;
} else if (type.startsWith("post")) {
  typeNum = 0;
} else if (type.startsWith("writeUp")) {
  typeNum = 2;
} else {
  message.error("审核项目不在审核范围内！");
}

const loadData = async () => {
  switch (typeNum) {
    case 0: {
      const res = await PostControllerService.getPostVoByIdUsingGet(id as any);
      if (res.code === 0) {
        data.value = res.data;
      } else {
        message.error("加载失败！ " + res.message);
      }
      break;
    }
    case 1: {
      const res =
        await PostCommentControllerService.getPostCommentVoByIdUsingGet(
          id as any
        );
      if (res.code === 0) {
        data.value = res.data;
      } else {
        message.error("加载失败！ " + res.message);
      }
      break;
    }
    case 2: {
      const res = await WriteUpControllerService.getWriteUpVoByIdUsingGet(
        id as any
      );
      if (res.code === 0) {
        data.value = res.data;
      } else {
        message.error("加载失败！ " + res.message);
      }
      break;
    }
    default:
      message.error("审核项目不在审核范围内！");
  }
};
onMounted(() => {
  loadData();
});
const auditAction = ref<AuditRequest>({
  id: id as any,
  type: typeNum,
});
const doAuditPass = async () => {
  const res = await AuditControllerService.doAuditUsingPost({
    ...auditAction.value,
    operation: 1,
  });
  if (res.code === 0) {
    message.success("提交成功！");
  } else {
    message.error("加载失败！ " + res.message);
  }
};
const doAuditFailed = async () => {
  const res = await AuditControllerService.doAuditUsingPost({
    ...auditAction.value,
    operation: 2,
  });
  if (res.code === 0) {
    message.success("提交成功！");
  } else {
    message.error("加载失败！ " + res.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { style: {"margin-bottom":"32px"} }, "详情", -1)),
    _createVNode(_component_a_form, { "label-align": "right" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "ID"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              placeholder: _unref(id),
              class: "formItem",
              disabled: ""
            }, null, 8, ["placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              placeholder: data.value?.title ?? '帖子评论无标题',
              class: "formItem"
            }, null, 8, ["placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "content",
          label: "内容"
        }, {
          default: _withCtx(() => [
            _createVNode(MdViewer, {
              value: data.value?.content,
              class: "formItem"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              "html-type": "submit",
              style: {"width":"150px","margin":"0 auto"},
              type: "primary",
              onClick: doAuditPass
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("审核通过 ")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              "html-type": "submit",
              style: {"width":"150px","margin":"0 auto"},
              type: "primary",
              onClick: doAuditFailed
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("退回 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})